module.exports = __webpack_public_path__ + "static/media/triangle.e0ee32e2.svg";